<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-buy-in`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 16a1 1 0 011 1v23h32V17a1 1 0 011-1h2a1 1 0 011 1v25a2 2 0 01-2 2H6a2 2 0 01-2-2V17a1 1 0 011-1h2zM23.01 4.905l1.893.008a1 1 0 01.996.995l.08 18.207 4.235-4.235a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.415l-7.778 7.778a2 2 0 01-2.828 0l-7.778-7.778a1 1 0 010-1.415l1.414-1.414a1 1 0 011.414 0l4.601 4.602-.082-18.573a1.002 1.002 0 011.004-1.004z"/></svg>
</template>
<script>

export default {
  name: 'IconBuyIn',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
